import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faCheckCircle, faCircleDollar, faCircleExclamation, faTrash } from "@fortawesome/pro-regular-svg-icons";
import moment from "moment";
import classNames from "classnames";
import "components/bookingPopUp/auditTrailNote/AuditTrailNote.scss";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faArrowRightArrowLeft, faUserMinus } from "@fortawesome/pro-solid-svg-icons";

/**
 * @param {string} title title of the action performed
 * @param {any} author user logged in when action happened
 * @param {any} actions more details about actions performed on the booking
 * @param {string} action action performed on the booking - create, modify, delete, notification
 * @param {string} timestamp time the action took place
 * @param {boolean} last check for last note in array of Audit Trail Notes
 */

export interface IAuditState {
  title: string;
  author: any;
  actions: any;
  action: string;
  timestamp: string;
  last: boolean;
}

function AuditTrailNote(props: IAuditState) {
  const [auditState] = useState<IAuditState>({
    title: props.title,
    author: props.author,
    actions: props.actions,
    action: props.action,
    timestamp: props.timestamp,
    last: props.last,
  });

  // function updateAuditState(newTimerState: Partial<IAuditState>) {
  //   setAuditState(cur => {
  //     return { ...cur, ...newTimerState };
  //   });
  // }

  let icon: IconDefinition = null;

  if (
    auditState.action === "create" ||
    auditState.action === "create_booking" ||
    auditState.action === "move" ||
    auditState?.action === "move_booking" ||
    auditState.action === "create_tee_time"
  ) {
    icon = faCheckCircle;
  } else if (auditState?.action === "modify" || auditState.action === "modify_tee_time" || auditState.action === "no_show") {
    icon = faCircleExclamation;
  } else if (auditState.action === "switch") {
    icon = faArrowRightArrowLeft;
  } else if (auditState.action === "remove") {
    icon = faUserMinus;
  } else if (auditState?.action === "delete" || auditState.action === "delete_booking") {
    icon = faTrash;
  } else if (auditState.action === "notification") {
    icon = faBell;
  } else if (auditState.action === "no_show_paid") {
    icon = faCircleDollar;
  }

  return (
    <div>
      <div className="bm-audit-trail-note-container">
        <div className="bm-audit-circle-line-container">
          <div
            className={classNames({
              "bm-audit-trail-circle-create":
                auditState.action === "create" ||
                auditState.action === "create_booking" ||
                auditState.action === "move" ||
                auditState?.action === "move_booking" ||
                auditState.action === "create_tee_time",
              "bm-audit-trail-circle-modify": auditState.action === "modify" || auditState.action === "modify_tee_time" || auditState.action === "no_show" || auditState.action === "switch",
              "bm-audit-trail-circle-delete": auditState.action === "delete" || auditState.action === "delete_booking" || auditState.action === "remove",
              "bm-audit-trail-circle-notification": auditState.action === "notification",
              "bm-audit-trail-circle-add": auditState.action === "no_show_paid",
            })}
          >
            <FontAwesomeIcon
              icon={icon}
              className={classNames({
                "bm-audit-trail-circle-create_icon":
                  auditState.action === "create" ||
                  auditState.action === "create_booking" ||
                  auditState.action === "move" ||
                  auditState?.action === "move_booking" ||
                  auditState.action === "create_tee_time",
                "bm-audit-trail-circle-modify_icon":
                  auditState.action === "modify" || auditState.action === "modify_tee_time" || auditState.action === "no_show" || auditState.action === "switch" ,
                "bm-audit-trail-circle-delete_icon":
                  auditState.action === "delete" || auditState.action === "delete_booking" || auditState.action === "remove",
                "bm-audit-trail-circle-notification_icon": auditState.action === "notification",
                "bm-audit-trail-circle-add_icon": auditState.action === "no_show_paid",
              })}
            />
          </div>
        </div>

        <div className="bm-audit-note-action-container">
          <div className="flex flex-col">
            <p className="bm-audit-trail-action-title">{auditState.title}</p>

            {auditState.actions?.map((action: any, index: number) => {
              return (
                <React.Fragment key={index}>
                  <div>
                    <p className="bm-audit-trail-action-description">
                      <span>{action.description}</span>
                    </p>
                  </div>
                </React.Fragment>
              );
            })}
          </div>

          <p className="bm-audit-trail-action-date">
            <span>{moment(auditState.timestamp).format("lll")}</span>
            <span>{auditState.author?.full_name}</span>
          </p>
        </div>
      </div>

      {!auditState.last ? <div className="bm-audit-trail-line"></div> : null}
    </div>
  );
}

export default AuditTrailNote;
